<div class="verifyPhoneNumber_container" [ngClass]="{'is-mobile-view': isMobileView}">
    <span class="verifyPhoneNumber_header" [ngClass]="{'is-mobile-view': isMobileView}">{{"verifyPhoneNubmer.header" | translate}}</span>
    @if(!isLoading){
        @if(!isVerificationProcessCompleted){
            <span class="verifyPhoneNumber_desc" [ngClass]="{'is-mobile-view': isMobileView}" [translate]="'verifyPhoneNubmer.description'" [translateParams]="{phoneNumber : user!.phoneNumber}"> </span>
            <div class="verifyPhoneNumber_desc_digitsInputs">
                <app-digits-input (stringSubmitted)="codeSubmitted($event)"></app-digits-input>        
            </div>    
            <div class="verifyPhonerNumber_action" [ngClass]="{'is-mobile-view': isMobileView}">
                <button mat-raised-button color="primary" (click)="close()">{{"verifyPhoneNubmer.cancelButton" | translate}}</button>
                <button mat-raised-button color="primary" (click)="retryVerification()" [disabled]="!isAllowedToResend">{{"verifyPhoneNubmer.resendVerificationNumberButton" | translate : translationParams}}</button>
            </div>   
        }
        @else if(verificationProcessSucceeded) {
            <span class="verifyPhoneNumber_desc" [ngClass]="{'is-mobile-view': isMobileView}">{{'verifyPhoneNubmer.success' | translate}}</span>
            <img class="verifyPhoneNumber_successImage" [src]="imageRootFolder+'phoneNumberVerified.svg'">
            <button mat-raised-button color="primary" (click)="close()">{{"verifyPhoneNubmer.closeButton" | translate}}</button>
        }
        @else{
            <span class="verifyPhoneNumber_desc" [ngClass]="{'is-mobile-view': isMobileView}">{{'verifyPhoneNubmer.fail' | translate}}</span>
            <img class="verifyPhoneNumber_successImage" [src]="imageRootFolder+'phoneNumberVerificatioFailed.svg'">
            <div class="verifyPhonerNumber_action" [ngClass]="{'is-mobile-view': isMobileView}">
                <button mat-raised-button color="primary" (click)="close()">{{"verifyPhoneNubmer.cancelButton" | translate}}</button>
                <button mat-raised-button color="primary" (click)="retryVerificationAfterFailure()">{{"verifyPhoneNubmer.retryVerificationProcess" | translate : translationParams}}</button>
            </div>   
        }
    }
    @else{
        <mat-spinner [diameter]="30"></mat-spinner>
    }
</div>